export const ROOM_LIMITS = [2, 5, 10, 50, 100]

export const ROOM_BACKGROUNDS = [
  { id: 'night', label: 'Night' },
  { id: 'sunset', label: 'Sunset' },
  { id: 'ocean', label: 'Ocean' },
  { id: 'forest', label: 'Forest' },
  { id: 'studio', label: 'Studio' },
  { id: 'neon', label: 'Neon' },
  { id: 'dawn', label: 'Dawn' },
  { id: 'ember', label: 'Ember' }
]

export const fetchRooms = async () => {
  const res = await fetch('/api/rooms')
  const data = await res.json().catch(() => null)
  if (!data || !Array.isArray(data.rooms)) throw new Error('Could not load rooms. Restart the API and try again.')
  return data.rooms
}

export const createRoom = async (body) => {
  const res = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  const data = await res.json().catch(() => null)
  if (!data || !data.room) throw new Error((data && data.msg) || 'Could not create room. Restart the API and try again.')
  return data.room
}
